import { render, staticRenderFns } from "./TemplateForm.vue?vue&type=template&id=6ad1b518&"
import script from "./TemplateForm.vue?vue&type=script&lang=js&"
export * from "./TemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports